// src/components/SuperAdmin/Dashboard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-100 p-6">
            <header className="mb-6">
                <h2 className="text-3xl font-semibold">Welcome to Super Admin Dashboard</h2>
            </header>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <button
                    onClick={() => navigate('/project-dashboard')}
                    className="py-6 bg-indigo-700 rounded shadow hover:bg-indigo-900 text-center font-medium"
                >
                    Projects
                </button>

                <button
                    onClick={() => navigate('/developer-dashboard')}
                    className="py-6 bg-indigo-700 rounded shadow hover:bg-indigo-900 text-center font-medium"
                >
                    Developers
                </button>

                <button
                    onClick={() => navigate('/brand-details')}
                    className="py-6 bg-indigo-600 rounded shadow hover:bg-indigo-800 text-center font-medium"
                >
                    Manage Brand
                </button>
            </div>
        </div>
    );
}
